import React, { Suspense } from 'react';

import Datagrid from 'ui/components/data/grid';
import Zoom from 'react-medium-image-zoom';

import { formatDate } from 'utilities/common';

import _ from 'underscore';

const Maps = React.lazy(() => import('ui/components/maps/mapbox.order'));

const List = ({ log, content }) => {
  return (
    <li className="pb-4">
      <div className="log-timestamp">
        <div className="d-flex justify-content-between">
          <div>{formatDate(log, 'HH:mm')}</div>
        </div>
      </div>
      <div className="text-muted" style={{ wordWrap: 'break-word' }}>
        {content}
      </div>
    </li>
  );
};

const OrderComp = ({ data }) => {
  const [logs, setLogs] = React.useState(null);

  const $convertLogs = async () => {
    let newLog = [];
    let newData = null;

    _.each(data?.trackings, function (log) {
      const payload = {
        ...log,
        recorded_at_filter: formatDate(log?.recorded_at, 'YYYY-MM-DD'),
      };

      newLog.push(payload);
    });

    if (newLog?.length > 0) {
      newData = _.groupBy(newLog, function (log) {
        return log?.recorded_at_filter;
      });
    }

    setLogs(newData);
  };

  React.useEffect(() => {
    $convertLogs();
  }, [data]);

  return (
    <div className="row">
      <div className="col-12 mb-3">
        <Suspense fallback={<div>Loading...</div>}>
          <Maps
            order={data?.order}
            manifest={data?.manifest}
          />
        </Suspense>
      </div>

      <div className="col-md-6 mb-3 mb-md-0">
        <div className="log-container border rounded-3 p-3 h-100 bg-white">
          <div className="fs-7 text-primary mb-3 border-bottom">
            Rute Pengiriman :{' '}
            <span className="text-secondary fw-bold">{data?.order?.code}</span>
          </div>
          {data?.manifest && data?.manifest?.legs ? (
            <>
              {data?.manifest?.legs?.map((leg, key) => (
                <div className="p-2 border-bottom" key={key}>
                  <div className="position-relative">
                    <div className="table-col">
                      <small className="info text-uppercase">
                        {key + 1}. {leg?.type?.replace('_point', '')} POINT
                      </small>
                      <div className="fs-8 fw-bold text-uppercase">
                        {leg?.location?.name}
                      </div>
                      <small className="info text-uppercase">
                        {leg?.location?.region?.district_name},{' '}
                        {leg?.location?.region?.regency_name},{' '}
                        {leg?.location?.region?.province_name}
                      </small>
                    </div>
                    <div className="position-absolute top-0 end-0">
                      <span className={`badge status-${leg?.status}-lt`}>
                        {leg?.status?.replace('_', ' ')}
                      </span>
                    </div>
                  </div>

                  <div className="row mt-2">
                    <div className="col-6">
                      <Datagrid
                        title="Waktu Keberangkatan"
                        value={formatDate(leg?.atd_at)}
                      />
                    </div>
                    <div className="col-6">
                      <Datagrid
                        title="Waktu Kedatangan"
                        value={formatDate(leg?.ata_at)}
                      />
                    </div>
                  </div>
                </div>
              ))}
            </>
          ): (
            <>
              {data?.order_legs?.map((leg, key) => (
                <div className="p-2 border-bottom" key={key}>
                  <div className="position-relative">
                    <div className="table-col">
                      <small className="info text-uppercase">
                        {key + 1}. {leg?.type?.replace('_point', '')} POINT
                      </small>
                      <div className="fs-8 fw-bold text-uppercase">
                        {leg?.location?.name}
                      </div>
                      <small className="info text-uppercase">
                        {leg?.location?.region?.district_name},{' '}
                        {leg?.location?.region?.regency_name},{' '}
                        {leg?.location?.region?.province_name}
                      </small>
                    </div>
                    <div className="position-absolute top-0 end-0">
                      <span className={`badge status-new-lt`}>
                        NEW
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}

          {data?.images?.length > 0 ? (
            <div className="d-flex flex-wrap gap-2 justify-content-center align-items-center pt-3">
              {data?.images?.map((d, i) => (
                <div key={i}>
                  <Zoom>
                    <div
                      style={{
                        width: 60,
                        height: 60,
                        backgroundColor: '#fff',
                        backgroundImage: `url(${d?.image.replace(
                          '_thumb',
                          ''
                        )})`,
                        backgroundSize: 'contain',
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat',
                      }}
                    />
                  </Zoom>
                </div>
              ))}
            </div>
          ) : null}
        </div>
      </div>
      <div className="col-md-6 ">
        <div className="log-container border rounded-3  p-3 h-100 bg-white">
          <div className="fs-7 text-primary mb-3">Log</div>
          <div
            style={{
              maxHeight: 500,
              overflowX: 'hidden',
              overflowY: 'auto',
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            {logs &&
              Object.entries(logs)?.map(([key, value]) => (
                <div className="row" key={key}>
                  <div className="col-4">
                    <div className="fs-8">
                      {formatDate(new Date(key), 'dddd,')}
                    </div>
                    <div className="fs-8 fw-bold">
                      {formatDate(new Date(key), 'DD MMMM YYYY')}
                    </div>
                  </div>
                  <div className="col-8">
                    <div className="log-timeline-new">
                      <ul className="log-new">
                        {value?.map((l, i) => (
                          <List
                            key={i}
                            content={l?.message}
                            log={l?.recorded_at}
                          />
                        ))}
                      </ul>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderComp;
